import { MobizSettingsValue } from './mobiz-settings-value.do';


/**
 * Domain object for the organization's synchronization settings.
 */
export class SynchronizationSettings extends MobizSettingsValue {
  AccountsModule: boolean;
  CustomerModule: boolean;
  CustomerTransactions: boolean;
  DimensionModule: boolean;
  InventoryModule: boolean;
  SalesModule: boolean;
  SystemModule: boolean;
  VendorTransactions: boolean;
  WorkModule: boolean;
}
